import { AccountCircle, Description, LocationOn} from '@mui/icons-material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Contacts from '@mui/icons-material/Contacts';
import GroupsIcon from '@mui/icons-material/Groups';
import { styled } from '@mui/material/styles';
import { collection, getDocs, query, where } from "firebase/firestore";
import { React, useEffect, useState } from 'react';
import Colors from "../colors";
import DashboardMenuItem from '../components/DashboardMenuItem';
import LoadingSpinner from '../components/LoadingSpinner';
import { db } from '../firebase';

const WelcomeMessage = styled('span')(() => ({
  fontWeight: '500',
  fontSize: '26px',
}));

function Dashboard({ user, isAdmin }) {
  const [username, setUsername] = useState('');
  const [formsInProgressCount, setFormsInProgressCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const fetchUsername = async () => {
      const usersRef = collection(db, 'Users');
      const q = query(usersRef, where("uid", "==", user.uid));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setUsername(doc.data().first_name);
      });
    };

    const fetchFormsInProgressCount = async () => {
      var count = 0;
      const formsRef = collection(db, 'Forms');
      const q = query(formsRef,
        where("userId", "==", user.uid),
        where("isArchived", "==", false));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        count++;
      });
      setFormsInProgressCount(count);
    };

    fetchUsername();
    fetchFormsInProgressCount();
    setIsLoading(false);
  }, [user, isAdmin]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {isLoading && <LoadingSpinner isLoading={isLoading} />}

      <div style={{ marginTop: '1rem', width: '90%' }}>
        <WelcomeMessage>Hello, {username}.</WelcomeMessage>
        <br />
        {formsInProgressCount === 0 &&
          <span>You have no Safety Tailgate forms in progress.</span>}
        {formsInProgressCount === 1 &&
          <span>You have 1 Safety Tailgate form in progress.</span>}
        {formsInProgressCount > 1 &&
          <span>You have {formsInProgressCount} Safety Tailgate forms in progress.</span>}
      </div>

      {/* <Button
        color={Colors.green}
        children={'View Forms In Progress'} /> */}

      <DashboardMenuItem
        color={Colors.green}
        icon={<Description sx={{ transform: 'scale(2)' }} />}
        label={'Safety Tailgate Forms'}
        subtitle={'Create and manage forms for pre-work safety meetings.'}
        link={'/tailgate-forms'} />

      <DashboardMenuItem
        color={Colors.blue}
        icon={<GroupsIcon sx={{ transform: 'scale(2)' }} />}
        label={'Teams'}
        subtitle={'Create and manage teams going into the field.'}
        link={'/teams'} />

      <DashboardMenuItem
        color={Colors.orange}
        icon={<Contacts sx={{ transform: 'scale(2)' }} />}
        label={'Contacts'}
        subtitle={'View contact information for key RENR personnel.'}
        link={'/contacts'} />

      <DashboardMenuItem
        color={Colors.red}
        icon={<LocationOn sx={{ transform: 'scale(2)' }} />}
        label={'Locations'}
        subtitle={'Manage locations and their associated emergency information.'}
        link={'/locations'} />

      {isAdmin &&  <DashboardMenuItem
        color={Colors.mediumGray}
        icon={<AdminPanelSettingsIcon sx={{ transform: 'scale(2)' }} />}
        label={'Update Permissions'}
        subtitle={'Grant or revoke admin access.'}
        link={'/admins'} /> }
        
      <DashboardMenuItem
        color={Colors.purple}
        icon={<AccountCircle sx={{ transform: 'scale(2)' }} />}
        label={'Account'}
        subtitle={'View and manage user account information.'}
        link={'/account'} />
      
    </div>
  )
}

export default Dashboard;